// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3e3d12f","large":"_90fe560","small":"_13c6d58","smaller":"_5ae9a87","verifyIcon":"_60c1239"};